import {BigWinView} from '@fantasmagames/slot/src/modules/bigwin/BigWinView';
import {SpineAnimation} from '@fantasmagames/core/src/display/SpineAnimation';
import {Spine} from '@fantasmagames/core/src/spine/Spine';
import {WinMeter} from '@fantasmagames/slot/src/modules/winpresentation/WinMeter';
import {Easing} from '@fantasmagames/core/src/tween/Easing';
import {WinNumbers} from '@fantasmagames/slot/src/modules/winpresentation/WinNumbers';

export class GameBigWinView extends BigWinView {

	public startWithMultiplier(fromNumber: number, winValue: number, bigWinLevel: number): void {
		this.killAllAnimations();

		this._currentWin = winValue;
		this._bigWinLevel = bigWinLevel;
		this._currentLevel = 1;

		this._isPlayingEndingEnd = false;

		this.show();

		this.initMeterWithMultiplier(fromNumber, winValue);

		this.startInitialAnimationsWithMultiplier();

		this.showNumber(`${fromNumber}`);
		this.startCounting();

		this.addMeterInto();
		this.addCurrentText();
	}

	protected setupWinNumber(): void {
		const winNumberFont = this.getFontSize(this.device.isMobile);

		this._winNumber = new WinNumbers(this.resources, winNumberFont);
		this._winNumber.currencyISO = this.currencyFormatter.currency;
		this._winNumber.currencySign = this.currencyFormatter.currencySign;
		this.adjustCurrencyOffset();

		this.container.addChild(this._winNumber);
	}

	protected adjustCurrencyOffset(): void {
		const currency = this.currencyFormatter.currency;

		if (currency === 'EUR' || currency === 'GBP' || currency === 'MYR' || currency === 'THB'
			|| currency === 'JPY' || currency === 'BOB' || currency === 'CAD' || currency === 'CHF'
			|| currency === 'CNY' || currency === 'COP' || currency === 'ARS' || currency === 'AUD'
			|| currency === 'DKK' || currency === 'GHS' || currency === 'HKD' || currency === 'ILS'
			|| currency === 'KES' || currency === 'MMK' || currency === 'MXN' || currency === 'NOK'
			|| currency === 'NZD' || currency === 'PEN' || currency === 'PHP' || currency === 'RWF'
			|| currency === 'SGD' || currency === 'TWD' || currency === 'ZAR') {
			this._winNumber.currencyOffset = {x: this.device.isMobile ? -20 : -20, y: 0};
		} else if (currency === 'PKR') {
			this._winNumber.currencyOffset = {x: -20, y: 0};
		} else if (currency === 'PLN' || currency === 'SEK') {
			this._winNumber.currencyOffset = {x: -20, y: 0};
		} else if (currency === 'CZK' || currency === 'HRK' || currency === 'HUF' || currency === 'RUB') {
			this._winNumber.currencyOffset = {x: -20, y: 0};
		} else {
			this._winNumber.currencyOffset = {x: 0, y: 10};
		}
	}

	protected initMeterWithMultiplier(fromValue: number, toValue: number): void {
		this._meter = new WinMeter(this._winNumber, Easing.Cubic.Out, this.currencyFormatter, true);
		// this._meter.setTextAdditionalOffsets(0, -25);
		this._meter.onCompleteCallback = this.onMeterFinished.bind(this);
		this._meter.from(fromValue).to(toValue, this.getCountingTime());

		this._meter.resolutionWidth = this.resolutionManager.resolution.width;
	}

	protected addMeterInto(): void {
		const container: PIXI.Container = this.spineUtils.findSlotContainerByName(this._currentAnimation.container as Spine, 'WIN_NUMBER');

		this._winNumber.rotation = Math.PI;
		this._winNumber.skew.y = Math.PI;
		this._winNumber.anchor.set(0.5, 0.5);
		this._winNumber.numberAnchor = {x: 0.0, y: 0.5};
		this._winNumber.numberKerning = -25;

		container.removeChildren();
		container.addChild(this._winNumber);
	}

	protected startInitialAnimationsWithMultiplier(): void {
		this._backgroundAnimation = this.spineUtils
			.startSpineAnimationCreation('BIG_WINS_GLOW.json', 'START', false)
			.position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
			.chainIdleAnimation(`IDLE${this.getCurrentLevelAnimationPostfix()}`)
			.container(this._backgroundContainer)
			.createAndStart();

		this._currentAnimation = this.spineUtils
			.startSpineAnimationCreation('BIG_WINS.json', 'START_MULTIPLIER', false)
			.position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
			.chainIdleAnimation(`IDLE${this.getCurrentLevelAnimationPostfix()}`)
			.container(this._foregroundContainer)
			.onComplete(() => {
				this.playBigWinLoop();
				this.emit(BigWinView.BIG_WIN_STARTED);
			})
			.createAndStart();

		let currentEffectIndex: number = 1;
		let hasMoreEffects: boolean = this.resources.hasSpine(`BIG_WINS_EFFECT_0${currentEffectIndex}.json`);

		while (hasMoreEffects) {
			const effect: SpineAnimation = this.spineUtils
				.startSpineAnimationCreation(`BIG_WINS_EFFECT_0${currentEffectIndex}.json`, 'START', false)
				.position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
				.chainIdleAnimation(`IDLE${this.getCurrentLevelAnimationPostfix()}`)
				.container(this.getEffectContainer(currentEffectIndex))
				.createAndStart();
			this._effectAnimation.push(effect);

			currentEffectIndex++;
			hasMoreEffects = this.resources.hasSpine(`BIG_WINS_EFFECT_0${currentEffectIndex}.json`);
		}
	}

	protected getEffectContainer(effectIndex: number): PIXI.Container {
		return this._middleContainer;
	}
}



// WEBPACK FOOTER //
// ./src/bigwin/GameBigWinView.ts